import {Injectable, OnDestroy} from '@angular/core';
import {Platform, AnimationController} from '@ionic/angular';
import {Observable, Subscription} from 'rxjs';
import type { Animation } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs';
import {ThemeType} from '../data/platform/theme.type';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  private resizeSubscription!: Subscription;
  private themeModeSubject!: BehaviorSubject<ThemeType>;
  private animation!: Animation;
  isMobile!: boolean;
  menuIsCollapsed: boolean = false;
  themeMode!: ThemeType;
  themeModeListener!: Observable<ThemeType>;
  viewport: { width: number; height: number; } = { width: 0, height: 0 };
  constructor(
    private platform: Platform,
    private animationCtrl: AnimationController,
    private storageService: StorageService,
  ) {
    this.themeMode = (
      window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    ) ? 'dark' : 'light';
    this.themeModeSubject = new BehaviorSubject<ThemeType>(this.themeMode);
    this.themeModeListener = this.themeModeSubject.asObservable();
    this.storageService.get(StorageService.Keys.themeMode).then(value => {
      if (value) this.toggleTheme(value);
    });
    this.storageService.get(StorageService.Keys.menuIsCollapsed).then(value => {
      if (value === true) this.toggleMenu(value);
    });
    this.isMobile = this.platform.is('mobile');
    this.viewport = {
      width: this.platform.width(),
      height: this.platform.width()
    }
    this.onResize();
  }

  ngOnDestroy(): void {
    this.resizeSubscription.unsubscribe();
    this.animation?.destroy();
  }

  toggleMenu(value?: boolean): void {
    this.menuIsCollapsed = value !== undefined && value !== null ? value : !this.menuIsCollapsed;
    this.storageService.set(StorageService.Keys.menuIsCollapsed, this.menuIsCollapsed);
    if (!this.animation) {
      this.animation = this.animationCtrl
        .create()
        .addElement(document.querySelector('.app-layout-menu')!)
        .duration(80)
        .iterations(1)
        .keyframes([
          { width: '200px' },
          { width: '70px' },
        ]);
    }
    this.animation.direction(!this.menuIsCollapsed ? 'reverse' : 'normal').play();
  }

  toggleTheme(value?: ThemeType): void {
    const prev = this.themeMode;
    this.themeMode = value !== undefined && value !== null
      ? value
      : (this.themeMode === 'light' ? 'dark' : 'light');
    const html = document.querySelector('html');
    if (html) {
      html.classList.remove(prev);
      setTimeout(() => {
        html.classList.add(this.themeMode);
      }, 0);
    }
    this.themeModeSubject.next(this.themeMode);
    this.storageService.set(StorageService.Keys.themeMode, this.themeMode);
  }

  onResize(cb?: (viewport?: { width: number; height: number; }) => void) {
    this.resizeSubscription?.unsubscribe();
    this.resizeSubscription = this.platform.resize.subscribe(() => {
      this.isMobile = this.platform.width() <= 768 || this.platform.is('mobile');
      this.viewport = {
        width: this.platform.width(),
        height: this.platform.width()
      }
      if (cb) cb(this.viewport);
    });
  };
}
